import LookupPersonInCcmsView from "./LookupPersonInCcmsView";
import { useLookupPersonInCcms } from "./useLookupPersonInCcms";

export type LookupPersonInCcmsProps = {
  pgaId: string;
  onFound: (pgaId: string) => void;
  /** `emptyState` for the people table; `inline` for quick search. */
  variant?: "emptyState" | "inline";
};

/**
 * Offers to look up a missing PGA ID in CCMS via ServiceBus sync, then navigates when the person appears.
 */
export default function LookupPersonInCcms({ pgaId, onFound, variant = "emptyState" }: LookupPersonInCcmsProps) {
  const { state, lookup } = useLookupPersonInCcms(pgaId, onFound);

  return <LookupPersonInCcmsView pgaId={pgaId} state={state} onLookup={() => void lookup()} variant={variant} />;
}
